import { flow } from 'lodash';
import { NAME } from './dialogs.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
